<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">姓名</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.ve_name" placeholder="请填写" />
          </div>
        </div>
        <virtual-org-field v-model="form.ve_orgname" @select="onSelectVirtualOrg" />
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">手机</label>
          </div>
          <div class="weui-cell__bd">
            <input
              v-if="mobileEditable"
              class="weui-input"
              type="text"
              v-model="form.ve_mobile"
              placeholder="请填写"
            />
            <span v-else>{{form.ve_mobile}}</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">邮箱</label>
          </div>
          <div class="weui-cell__bd">
            <input
              v-if="emailEditable"
              class="weui-input"
              type="text"
              v-model="form.ve_email"
              placeholder="请填写"
            />
            <span v-else>{{form.ve_email}}</span>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">公司名称</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.ve_corp_name"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">所属行业</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.ve_corp_industry"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">地址</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.ve_address"
              placeholder="请填写"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import VirtualOrgField from "@/components/field/VirtualOrgField.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    VirtualOrgField,
  },
  data() {
    return {
      baseUrl: "/api/document/virtual_org_emp",
      mobileEditable: true,
      emailEditable: true,
      form: {
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.ve_name) {
        me.$weui.topTips("请填写姓名", 2000);
      }
      else if(!main.ve_orgid) {
        me.$weui.topTips("请填写组织", 2000);
      }
      else if (!main.ve_mobile) {
        me.$weui.topTips("请填写手机号", 2000);
      }
      else {
        me.f_save();
      }
    },
    onSelectVirtualOrg(selected) {
      this.form.ve_orgname = selected.map((item) => item.vo_name).join(',')
      this.form.ve_orgid = selected.map((item) => item.id).join(',')
    },
  },
}
</script>